import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const PermissionsCtx = createContext({
  loading: true,
  permissions: [],
  role: null,
  userType: "",
  isMaster: false,
  can: () => false,
  refresh: () => {},
});

export function PermissionsProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    permissions: [],
    role: null,
    userType: "",
    isMaster: false,
  });

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("compass_token");
    if (!token) {
      setState((s) => ({ ...s, loading: false }));
      return;
    }
    try {
      const r = await fetch(`${API}/api/roles/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!r.ok) throw new Error("failed");
      const d = await r.json();
      setState({
        loading:     false,
        permissions: d.permissions || [],
        role:        d.role || null,
        userType:    d.user_type || "",
        isMaster:    !!d.is_master,
      });
    } catch {
      // Fall back to localStorage user_type so the app still renders even
      // if the endpoint is temporarily unreachable.
      const userType = localStorage.getItem("compass_user_type") || "";
      const isMaster = localStorage.getItem("compass_is_master") === "true";
      setState({
        loading:     false,
        permissions: [],
        role:        null,
        userType,
        isMaster,
      });
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const can = useCallback(
    (permKey) => {
      if (state.isMaster) return true;
      return state.permissions.includes(permKey);
    },
    [state]
  );

  return (
    <PermissionsCtx.Provider value={{ ...state, can, refresh: fetchMe }}>
      {children}
    </PermissionsCtx.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsCtx);
}
